import { createContext } from 'react';

const UnheadContext = createContext(null);

export { UnheadContext as U };
